import { GprRule, GprTerm } from "./getSiteHealthConfig";

const evaluateTerm = (
  term: GprTerm,
  designedPrPct: number | null
): number | null => {
  if (term.type === "flat") return term.valuePct;
  if (designedPrPct == null) return null;
  if (term.type === "fractionOfDesignedPr")
    return designedPrPct * term.fraction;
  return designedPrPct - term.deltaPct;
};

/**
 * Reduce a GprRule and a Designed PR to a single effective GPR percentage.
 * Returns null when the rule references Designed PR but Designed PR is unset,
 * matching the backend's fail-safe behaviour.
 */
export const evaluateGprRule = (
  rule: GprRule | null,
  designedPrPct: number | null
): number | null => {
  if (rule == null) return null;
  if (rule.type === "max" || rule.type === "min") {
    const values = rule.terms.map((t) => evaluateTerm(t, designedPrPct));
    if (values.some((v) => v == null)) return null;
    const clean = values as number[];
    return rule.type === "max" ? Math.max(...clean) : Math.min(...clean);
  }
  return evaluateTerm(rule, designedPrPct);
};

/** Does a rule reference Designed PR (and therefore require it to be set)? */
export const ruleRequiresDesignedPr = (rule: GprRule | null): boolean => {
  if (rule == null) return false;
  const referencesDesigned = (t: GprTerm) =>
    t.type === "fractionOfDesignedPr" || t.type === "designedPrMinus";
  if (rule.type === "max" || rule.type === "min") {
    return rule.terms.some(referencesDesigned);
  }
  return referencesDesigned(rule);
};
